import { AxiosError, AxiosResponse } from 'axios';
import instance, { ApiError } from '../../api/instance';
import { CompanyAccount } from './companyAccounts.types';

const companyAccountsApiPath = `/company-accounts`;

export const getAccounts = async ({
  name,
  email,
}: {
  name?: string;
  email?: string;
}): Promise<AxiosResponse<CompanyAccount[] & ApiError>> => {
  return instance
    .get<CompanyAccount[]>(companyAccountsApiPath, { params: { email, name } })
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const createAccount = async (
  data: Partial<CompanyAccount>
): Promise<AxiosResponse<CompanyAccount & ApiError>> => {
  return instance
    .post<CompanyAccount>(companyAccountsApiPath, data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

const companyAccountApiPath = (accountId: string) => `/company-accounts/${accountId}`;

export const getAccount = async ({
  accountId,
}: {
  accountId: string;
}): Promise<AxiosResponse<CompanyAccount & ApiError>> => {
  return instance
    .get<CompanyAccount>(companyAccountApiPath(accountId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const updateAccount = async ({
  accountId,
  data,
}: {
  accountId: string;
  data: Partial<CompanyAccount>;
}): Promise<AxiosResponse<CompanyAccount & ApiError>> => {
  return instance
    .post<CompanyAccount>(companyAccountApiPath(accountId), data)
    .catch(e => e.response as AxiosError<ApiError> as never);
};

export const deleteAccount = async ({
  accountId,
}: {
  accountId: string;
}): Promise<AxiosResponse<CompanyAccount & ApiError>> => {
  return instance
    .delete<CompanyAccount>(companyAccountApiPath(accountId))
    .catch(e => e.response as AxiosError<ApiError> as never);
};
